<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div v-for="highLight in items.highlightArea" :key="highLight.index">
              <div
              class="user-guide-top"
              :style="{
                height: (highLight.top + isMsgTop) + 'px',
                left: highLight.left + 'px',
                width: highLight.width + 'px',

              }"></div>
            <div
              class="user-guide-left"
              :style="{
                left: (highLight.index == 0 ? 0: (items.highlightArea[highLight.index - 1].left + items.highlightArea[highLight.index - 1].width )) + 'px',
                width:(highLight.index == 0 ? highLight.left: ( highLight.left - items.highlightArea[highLight.index - 1].left - items.highlightArea[highLight.index - 1].width )) + 'px',
              }"></div>
            <div v-if="highLight.index == (items.highlightArea.length - 1)"
              class="user-guide-right"
              :style="{
                left: highLight.left + highLight.width + 'px',
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: highLight.top + isMsgTop + highLight.height + 'px',
                left: highLight.left + 'px',
                width: highLight.width + 'px',

              }"></div>
            </div>
            
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left:  items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content">{{ items.content }}</div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
                <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="items.btnList.includes('know')" @click="nextTask" class="gj-pointer knowBtn">我知道了</div>
              <div v-if="items.btnList.includes('complete')" @click="completeTask" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <div class="user-guide-point" v-if="items.lineType != 3 " :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
          <div v-if="items.lineType && hightLightWidth != 0"  class="user-guide-point-right" :style="{width:`${hightLightleft - 720}px`}">
            <div class="user-guider-line-right"></div>
          </div>
         
          <div v-if="items.lineType == 1"  class="user-guide-point-vertical">
            <div class="user-guider-line-vertical"></div>
            <div class="user-guider-line-right" :style="{width:`${clientWidth - 720}px`}"></div>
            <div class="user-guider-line-right-point" :style="{'margin-left':`${clientWidth - 720}px`}"></div>
          </div>  

          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {mapGetters} from "vuex";
import { number } from '@/filters';
import {userGuideMixin} from "@/minxins";
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'

export default {
  name: "new-user-guide",
  mixins: [userGuideMixin],
  props: {
    guideRef: {
      value: null
    },
    userGuideHighLightLeft:Number
  },
  data() {
    return {
      bootSteps: 0,
      startStep: 'storeAuthorize',
      data: [],
      hightLightleft:0,
      hightLightWidth:0,
      taskName: '',
      taskList: {},
      isMsgTop: 0,
      clientWidth: 0,
      taskItem: {},
    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate : true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    },
    userGuideHighLightLeft:{
      handler(left) {
        this.hightLightleft = left
        if(this.taskList.storeAuthorize){
          this.hightLightleft = left - 10
          if (left > this.taskList.storeAuthorize[0].highlightArea[2].left) {
            left = 0
            this.hightLightleft = 0
          }
          if(left == 0 ) {
            this.hightLightWidth = 0
          }else {
            this.hightLightWidth = 110
            this.taskList.storeAuthorize[0].highlightArea[1].left = this.hightLightleft
          }
          this.taskList.storeAuthorize[0].highlightArea[1].width = this.hightLightWidth
          this.$forceUpdate()
          }
      },
      immediate : true
    }
  },
  created() {
    this.taskItem = this.userGuideTaskItem
    this.bootSteps = 1;
    this.taskName = this.startStep;
    this.clientWidth = document.body.clientWidth
    const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
    const subtractHeight =  isNavHorizontal ? 0 : 44; 
    const addWidth =  isNavHorizontal ? 0 : 58; 
    this.subtractHeight = subtractHeight;
    this.taskList= {
        storeAuthorize: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: [
              {
              width: 150,
              height: 200,
              top: 135 - subtractHeight,
              left: 30 + addWidth,
              index:0
            },
              {
              width: 0,
              height: 800,
              top: 195,
              left: 400,
              index:1
            },{
              width: 150,
              height: 200,
              top: 285 - subtractHeight,
              left: 1600,
              right:50,
              index:2
            }],
            guideArea: {
              top: 230 - subtractHeight,
              left: 300 + addWidth,
            },
            guideWidth: 60,
            content: "您可通过点击这些按钮，去关联产品~如果没有做产品与listing关联关系维护，则您无法在系统完成发货到FBA仓的流程哦~",
            btnList: ['video'],
            lineType:1,
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'modal',
            needMask: false,
            modalArea: {
              width: 1000
            },
            guideWidth: 60,
            guideRef: null,
            content: "您可以在列表选择需要关联的产品后，点击【关联】按钮；如果在列表中没有需要关联的产品，您可以点击【快速生成SKU】进行关联哦~",
            btnList: [],
          },
          {
            id: 3,
            class: "user-guide-three",
            type: 'default',
            highlightArea: [{
              width: 100,
              height: 100,
              top: 195 - subtractHeight,
              left: 1340 + addWidth,
              index:0
            }],
            needMask: true,
            guideArea: {
              top: 230 - subtractHeight,
              left: 300 + addWidth,
            },
            guideWidth: 60,
            content: "关联产品成功后，列表上就会显示对应的产品名称和SKU编码哦~以后在其他页面中看到这个按钮，点击后也可以去做关联产品哦~",
            btnList: ['complete'],
            lineType:3,
          }
        ],
  
      }

    this.taskList.storeAuthorize[0].highlightArea[2].left = this.clientWidth - (this.taskList.storeAuthorize[0].highlightArea[2].width + this.taskList.storeAuthorize[0].highlightArea[2].right)
    this.data = this.taskList[this.startStep];
      if(this.hightLightleft != 0){
          this.hightLightleft  = this.hightLightleft  - 10
          if (this.hightLightleft  > this.taskList.storeAuthorize[0].highlightArea[2].left) {

            this.hightLightleft = 0
          }
          if(this.hightLightleft  == 0 ) {
            this.hightLightWidth = 0
          }else {
            this.hightLightWidth = 110
            this.taskList.storeAuthorize[0].highlightArea[1].left = this.hightLightleft
            this.taskList.storeAuthorize[2].highlightArea[0].left = this.hightLightleft

          }
          this.taskList.storeAuthorize[0].highlightArea[1].width = this.hightLightWidth
          this.$forceUpdate()
          }

    this.$nextTick(()=> {
      this.$forceUpdate()
    })
  },
  methods: {
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      this.bootSteps++;
      let activeItem = this.data.find(item => item.id === this.bootSteps);
      if(activeItem && activeItem.type === 'menu') {
        this.$store.commit(SET_USER_GUIDE_MENU_PATH, activeItem.path);
      }
    },
    nextTask() { // 下个任务
      if(this.taskName === 'storeAuthorize') {
        this.bootSteps = 2;
        this.data = this.taskList.adAuthorize;
        this.taskName = 'adAuthorize';
        this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      } else if(this.taskName === 'adAuthorize') {
        // 根据起始步骤判断是否跳过步骤一
        if(this.startStep === 'adAuthorize') {
          this.bootSteps = 1;
          this.data = this.taskList.mailboxAuthorize;
          this.taskName = 'mailboxAuthorize';
          this.$emit('closeModal')
          this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
        } else {
          this.bootSteps = 2;
          this.data = this.taskList.mailboxAuthorize;
          this.taskName = 'mailboxAuthorize';
          this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
        }
      }
    },
    openNoviceGuide() {
      this.bootSteps = 2
      this.startStep = ''
      this.data = [];
      this.$gjCreate(NoviceGuide)
    },
    async completeTask() {

      const taskItem = this.taskItem
      const {finishTaskList, nextTask} =  await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode)

      if (nextTask){
        if (this.isWaitTurnOn(nextTask.taskStatus)){// 任务未开启，需要 打开新手指引弹窗
          this.$message.warning( `${nextTask.taskChildName}任务未开启，请先开启任务~`)
          this.openNoviceGuide();
        }else {//下一步不属于当前组件，跳转新页面
          this.jumpToGuidePage(nextTask, () => {
            this.bootSteps = 0;
            this.$emit('finishGuide');
            this.$emit('closeModal');
          })
        }
      }else {
        //当前子任务列表全部完成
        if (this.taskItem.taskStatus != 'COMPLETED' && finishTaskList){
          this.bootSteps = 0;
          this.data = [];
          this.$emit('closeModal');
          this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
          this.$gjCreate(appUserGuideSucc,{
            global: true,
            props: {
              id: this.taskItem?.taskTypeCode
            }
          })
        }else {
          this.cancel()
        }
      }
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point-vertical {
    width: 30px;
    position: absolute;
    left: 50%;
    top: 100%;

    .user-guider-line-vertical {
      width: 2px;
      height: 120px;
      background: #4994FC;
      
    }
    .user-guider-line-right {
      width: 100%;
      height: 2px;
      background: #4994FC;
    }
    .user-guider-line-right-point {
      border: 1px solid #4994FC;
        background-color: #4994FC;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left:100%;
        margin-top: -5px;
    }
   
  }
  .user-guide-point-right {
    width: 400px;
    position: absolute;
    left: 400px;
    top: 10%;
    .user-guider-line-right {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
        margin-left:100%;
      }
    }
  }
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>